<script setup lang="ts">
import TagItem from '@/components/Tags/TagItem.vue'
import type { FilterTagModel } from '@/types/components/FilterTagModel'
import { StackLayout } from '../Layouts'

type Props = {
    data: FilterTagModel[]
}
defineProps<Props>()
type Emits = {
    (e: 'close', item: FilterTagModel, index: number): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout :gap="4" class="flex-wrap">
        <TagItem
            v-for="(item, index) in data"
            :key="index"
            :item="item"
            @close="$emit('close', item, index)"
            v-bind="$attrs" />
    </StackLayout>
</template>
